import React, { useState } from 'react';
import { MenuIcon, XIcon, MessageSquareIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white text-blue-900 sticky top-0 z-50 shadow-md" data-id="element-108">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-109">
        <div className="flex items-center" data-id="element-110">
          <div className="flex items-center" data-id="element-111">
            <Logo width={150} data-id="element-112" />
          </div>
        </div>
        <div className="hidden md:flex items-center space-x-8" data-id="element-113">
          <nav data-id="element-114">
            <ul className="flex space-x-6" data-id="element-115">
              <li data-id="element-116">
                <a href="#hizmetler" className="hover:text-green-500 transition font-medium" data-id="element-117">
                  Hizmetler
                </a>
              </li>
              <li data-id="element-118">
                <a href="#hakkimizda" className="hover:text-green-500 transition font-medium" data-id="element-119">
                  Neden Biz?
                </a>
              </li>
              <li data-id="element-120">
                <a href="#iletisim" className="hover:text-green-500 transition font-medium" data-id="element-121">
                  İletişim
                </a>
              </li>
            </ul>
          </nav>
          <a href="https://wa.me/905322847563" target="_blank" rel="noopener noreferrer" className="flex items-center bg-green-600 text-white font-bold px-4 py-2 rounded-md hover:bg-green-700 transition" data-id="element-122">
            <MessageSquareIcon className="w-4 h-4 mr-2" data-id="element-123" />
            <span data-id="element-124">WhatsApp'dan iletişime geçin</span>
          </a>
        </div>
        <div className="md:hidden" data-id="element-125">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-blue-900" data-id="element-126">
            {isMenuOpen ? <XIcon className="w-6 h-6" data-id="element-127" /> : <MenuIcon className="w-6 h-6" data-id="element-128" />}
          </button>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-t px-4 py-4" data-id="element-129">
          <nav data-id="element-130">
            <ul className="flex flex-col space-y-3" data-id="element-131">
              <li data-id="element-132">
                <a href="#hizmetler" className="block hover:text-green-500 transition" onClick={() => setIsMenuOpen(false)} data-id="element-133">
                  Hizmetler
                </a>
              </li>
              <li data-id="element-134">
                <a href="#hakkimizda" className="block hover:text-green-500 transition" onClick={() => setIsMenuOpen(false)} data-id="element-135">
                  Neden Biz?
                </a>
              </li>
              <li data-id="element-136">
                <a href="#iletisim" className="block hover:text-green-500 transition" onClick={() => setIsMenuOpen(false)} data-id="element-137">
                  İletişim
                </a>
              </li>
            </ul>
          </nav>
          <a href="https://wa.me/905322847563" target="_blank" rel="noopener noreferrer" className="mt-4 flex items-center justify-center bg-green-600 text-white font-bold px-4 py-2 rounded-md hover:bg-green-700 transition" data-id="element-138">
            <MessageSquareIcon className="w-4 h-4 mr-2" data-id="element-139" />
            <span data-id="element-140">WhatsApp'dan iletişime geçin</span>
          </a>
        </div>}
    </header>;
}